export const AVERAGE = 'Average';
export const TOTAL = 'Total';
